import { AffiliateForm } from "modules/storyblok/components/AffiliateForm";
import { LegalPartnersForm } from "modules/storyblok/components/LegalPartnersForm";
import { BecomeAPartnerForm } from "modules/storyblok/components/BecomeAPartnerForm";
import type { Modals, RUICButtonSizes, RUICButtonVariants, SBButtonSizes, SBButtonVariants } from "./Button.d";

const modals: Record<Modals, JSX.Element> = {
  "legal-partners": <LegalPartnersForm />,
  affiliate: <AffiliateForm />,
  "become-a-partner": <BecomeAPartnerForm />,
};

const sizes: Record<SBButtonSizes, RUICButtonSizes> = {
  lg: "l",
  md: "m",
  sm: "s",
  xs: "xs",
};

const variants: Record<SBButtonVariants, RUICButtonVariants> = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "primaryAlt",
  subtle: "subtle",
  unstyled: "unstyled",
  link: "link",
  linkPrimary: "link",
  linkSecondary: "link",
  danger: "danger",
};

export { modals, sizes, variants };
